import React from 'react'
import { withRouter } from 'react-router-dom'
import { view } from 'react-easy-state'
import { Row, Col, Tooltip, Progress, Avatar, Empty, Button, Icon } from 'antd'

const SubjectList = (props) => {

  const { course, subjects, papers } = props

  const subjectColSpans = {
    xs: { span: 24, },
    sm: { span: 8 },
    md: { span: 6 },
  }

  const handleSubjectCardClick = (subjectId) => {
    props.history.push(`/subjects/${subjectId}/chapters`)
  }

  const handlePaperCardClick = (subjectId, paperId) => {
    props.history.push(`/papers/${paperId}`)
  }

  if (!subjects || subjects.length === 0) {
    return <div className="course-list no-course"><Empty description="No subject found"><Button type="primary" onClick={() => props.history.push(`/courses/`)}>Go Back</Button></Empty></div>
  }

  const goToPapersPage = () => {
    props.history.push(`/courses/${props.course.id}/papers`)
  }

  return (
    <div className="course-list">
      {subjects.length > 0 && <h3>Subjects</h3>}
      <Row gutter={20}>
        {
          subjects.map(subject => (
            <Col key={subject.id} {...subjectColSpans} className="m-t-20">
              <div className="course-item-card" onClick={() => handleSubjectCardClick(subject.id)}>
                <div className="course-image"><img src={subject.image_url} alt={subject.name} /></div>
                <div className="course-info">
                  <Tooltip placement="top" title={subject.name} arrowPointAtCenter>
                    <div className="course-title">{subject.name}</div>
                  </Tooltip>
                  {
                    false && <Progress
                      strokeColor={{
                        '0%': '#108ee9',
                        '100%': '#87d068',
                      }}
                      percent={subject.userProgress || 0}
                      strokeWidth={12}
                      showInfo={false}
                      style={{ margin: '15px 0px' }}
                    />
                  }

                  {
                    false && <div className="course-states">
                      <div className="course-auther">
                        <Avatar src={`https://i.pravatar.cc/150?u=${subject.id}`} /> <span>{subject.instructor && subject.instructor[0] && subject.instructor[0].name}</span>
                      </div>
                      <div className="course-completed">
                        <strong>{subject.userProgress || 0}%</strong>
                        <span> Completed</span>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </Col>
          ))
        }
        </Row>
        {papers.length > 0 && <h3 style={{ marginTop: 30 }}>Tests</h3>}
        <Row gutter={20} style={{ display: 'flex', flexWrap: 'wrap' }}>
        {
          papers.map(paper =>
            <Col {...subjectColSpans} className="m-t-20">
              <div className="course-item-card" onClick={() => handlePaperCardClick(1, paper.id)}>
                <div className="course-image"><img src={paper.image_url} alt={paper.name} /></div>
                <div className="course-info">
                  <Tooltip placement="top" title={paper.name} arrowPointAtCenter>
                    <div className="course-title">{paper.name}</div>
                  </Tooltip>
                </div>
              </div>
            </Col>
          )
        }
        {
          (course.total_papers > 3) && <Col {...subjectColSpans} className="m-t-20">
            <div  className="course-item-card more" onClick={() => goToPapersPage()}>
              <Icon type="arrow-right" />
              <p>View All Papers</p>
            </div>
          </Col>
        }

      </Row>
    </div>
  )

}

export default withRouter(view(SubjectList))
